module.exports = __webpack_public_path__ + "static/media/checkitoff-combined.30aa8e59.png";